var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
var MobileView = /** @class */ (function (_super) {
    __extends(MobileView, _super);
    function MobileView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileView.prototype.mounted = function () {
        if (screen.width > this.mobileBreakpoint) {
            this.useAsDesktop();
            return this.$router.push({
                name: 'TalentCard',
                params: {
                    jobId: this.$route.params.jobId,
                    candidateId: this.$route.params.talentId,
                },
            });
        }
        this.useAsMobile();
    };
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], MobileView.prototype, "useAsDesktop", void 0);
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], MobileView.prototype, "useAsMobile", void 0);
    __decorate([
        State,
        __metadata("design:type", Number)
    ], MobileView.prototype, "mobileBreakpoint", void 0);
    MobileView = __decorate([
        Component
    ], MobileView);
    return MobileView;
}(Vue));
export default MobileView;
